import {
  parseYuzuFontManifest,
  type YuzuFontManifest,
} from '@giftie/yuzu-integration'

const YUZU_FONT_STYLE_ID = 'yuzu-custom-fonts'

export async function applyYuzuFontManifest(manifest?: YuzuFontManifest) {
  const fonts = manifest ? parseYuzuFontManifest(manifest).fonts : []
  const style =
    document.getElementById(YUZU_FONT_STYLE_ID) ??
    document.head.appendChild(document.createElement('style'))

  style.id = YUZU_FONT_STYLE_ID
  style.textContent = fonts
    .map(
      (font) => `
    @font-face {
      font-family: ${JSON.stringify(font.family)};
      src: url(${JSON.stringify(font.shopifyCdnUrl)}) format(${JSON.stringify(font.format)});
    }
  `,
    )
    .join('\n')

  await Promise.all(
    fonts.map((font) =>
      document.fonts.load(`1em ${JSON.stringify(font.family)}`),
    ),
  )
}

/** Applies company variables; fonts use the same loaders as ordinary cards. */
export async function applyYuzuCompanyFonts(context?: {
  webFonts?: Array<{ family: string; src: string }>
  variables?: Record<string, string | number | null>
}) {
  // Built-in web fonts are loaded by main.css; custom fonts use fontManifest.
  // Do not block every company-card opening on another full catalogue stylesheet.
  for (const [key, value] of Object.entries(context?.variables ?? {})) {
    if (/^--brand-[a-z0-9-]+$/.test(key) && value != null)
      document.documentElement.style.setProperty(key, String(value))
  }
}
